<template>
    <div v-if="isLoading" class="data-fetch-overlay">
        <div class="spinner-container">
            <v-progress-circular
                indeterminate
                color="primary"
                size="64"
                width="6"
            ></v-progress-circular>
            <p class="loading-text">Loading data...</p>
        </div>
    </div>
</template>

<script>
export default {
    name: "DataFetchLoadingComponent",
    props: {
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
.data-fetch-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    backdrop-filter: blur(2px);
}

.spinner-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
}

.loading-text {
    color: white;
    font-size: 16px;
    font-weight: 500;
    margin: 0;
}
</style>

